export default __webpack_public_path__ + "static/media/Frame_1-removebg-preview.21c17934.png";